'use strict';

angular.module('substoreApp.services')
    .factory('orderProductTermsConfirmation', [ 'emailValidationService', function(emailValidationService) {
        var maxTextsToBeConfirmed = 10; // we do not support more than 10 texts to be confirmed

        function arrayOfBoolean(value) {
            var array = [];
            for (var i = 0; i < maxTextsToBeConfirmed; i++) // no, we cannot use Array.map because of IE8
                array[i] = value;
            return array;
        }

        function allTrue(values) {
            for (var i = 0; i < values.length; i++)
                if (!values[i])
                    return false;
            return true;
        }

        function setBoolArray(textToBeConfirmed, okAcceptTextToBeConfirmed, focusAcceptTextToBeConfirmed, acceptTextToBeConfirmed, focusSet) {
            for (var i = 0; i < textToBeConfirmed.length; i++) {
                okAcceptTextToBeConfirmed[i] = acceptTextToBeConfirmed[i];
                if(!okAcceptTextToBeConfirmed[i] && !focusSet) {
                    focusSet = focusAcceptTextToBeConfirmed[i] = true;
                }
            }
        }

        return function() {
            return {
                acceptTerms: false,
                acceptTextToBeConfirmed: arrayOfBoolean(false),
                acceptTextToBeConfirmedChange: arrayOfBoolean(false),
                acceptRescissionRights: false,
                customerEmail: undefined,
                customerVerificationEmail: undefined,
                emailVerification: false,
                ok: { acceptTerms: true, acceptTextToBeConfirmed: arrayOfBoolean(true), acceptTextToBeConfirmedChange: arrayOfBoolean(true), acceptRescissionRights: true, customerEmail: true, customerVerificationEmail: true },
                focus:  { acceptTerms: false, acceptTextToBeConfirmed: arrayOfBoolean(false), acceptTextToBeConfirmedChange: arrayOfBoolean(false), acceptRescissionRights: false, customerEmail: false, customerVerificationEmail: false },
                focusSet: false,
                failed: function (termsOrderLink, rescissionOrderLink, textToBeConfirmed, textToBeConfirmedChange, emailTextProductOrder) {
                    this.focusSet = false;

                    this.ok.acceptTerms = (!termsOrderLink || this.acceptTerms);
                    if(!this.ok.acceptTerms && !this.focusSet) this.focusSet = this.focus.acceptTerms = true;
                    this.ok.acceptRescissionRights = (!rescissionOrderLink || this.acceptRescissionRights);
                    if(!this.ok.acceptRescissionRights && !this.focusSet) this.focusSet = this.focus.acceptRescissionRights = true;

                    if ( textToBeConfirmedChange ) {
                        setBoolArray(textToBeConfirmedChange, this.ok.acceptTextToBeConfirmedChange, this.focus.acceptTextToBeConfirmedChange, this.acceptTextToBeConfirmedChange, this.focusSet);
                    }
                    if ( textToBeConfirmed ) {
                        setBoolArray(textToBeConfirmed, this.ok.acceptTextToBeConfirmed, this.focus.acceptTextToBeConfirmed, this.acceptTextToBeConfirmed, this.focusSet);
                    }

                    this.ok.customerEmail = (!emailTextProductOrder || ((this.customerEmail && emailValidationService.isValid(this.customerEmail))));
                    if(!this.ok.customerEmail && !this.focusSet) {
                        this.focusSet = this.focus.customerEmail = true;
                    }

                    this.ok.customerVerificationEmail = (!this.emailVerification || (this.customerEmail==this.customerVerificationEmail));
                    if(!this.ok.customerVerificationEmail && !this.focusSet) {
                        this.focusSet = this.focus.customerVerificationEmail = true;
                    }

                    return (!(this.ok.acceptTerms && this.ok.acceptRescissionRights && allTrue(this.ok.acceptTextToBeConfirmed) && allTrue(this.ok.acceptTextToBeConfirmedChange) && this.ok.customerEmail && this.ok.customerVerificationEmail));
                }
            }
        }
    } ]);